// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__qFVst","iconWrapper":"Notification_iconWrapper__i-lQV","textWrapper":"Notification_textWrapper__q5S15"};